import { ChatHistory as ChatHistoryNode } from "@acto/gql/graphql";
import type { StoredMessage } from "@acto/taskpane/core/chat/chatMessageHelpers";

import dayjs, { Dayjs } from "dayjs";

export default class ChatHistory {
  constructor(
    public readonly id: string,
    public readonly clientId: string,
    public readonly sessionId: string,
    public readonly messages: StoredMessage[],
    public readonly createdAt: Dayjs,
    public readonly updatedAt: Dayjs,
  ) {}

  static fromGraphql(data: ChatHistoryNode): ChatHistory {
    // If already transformed, return as-is
    if (data instanceof ChatHistory) {
      return data;
    }

    // Parse messages from JSON string to StoredMessage[]
    let parsedMessages: StoredMessage[] = [];
    try {
      parsedMessages = JSON.parse(data.messages) as StoredMessage[];
    } catch (error) {
      console.error("Failed to parse chat messages:", error);
      parsedMessages = [];
    }

    return new ChatHistory(
      data.id,
      data.client.id,
      data.sessionId,
      parsedMessages,
      dayjs.isDayjs(data.createdAt) ? data.createdAt : dayjs(data.createdAt),
      dayjs.isDayjs(data.updatedAt) ? data.updatedAt : dayjs(data.updatedAt),
    );
  }

  /**
   * Extracts the first user question from the messages for preview display
   * @returns The first user message text or empty string if not found
   */
  getPreviewText(): string {
    const firstUserMessage = this.messages.find((message) => message.role === "user");

    if (!firstUserMessage || !firstUserMessage.content) {
      return "";
    }

    return firstUserMessage.content;
  }
}
